import React from 'react';
import ReactDOM from 'react-dom';
import App from './views';

ReactDOM.render(<App />, document.getElementById('root'));
